export const environment = {
  production: false,
  gcpLogginEndpoint: '',
  apikeytest: '0101010101-DEV',
  apiCotizador: {
    baseUrl: 'https://gke-portalcorporativo-qa.gnp.com.mx',
    cotiza: '/portal-corporativo/functions/cotiza/retiro',
    recotiza: '/portal-corporativo/functions/cotiza/retiro-recotiza'
  }
};